<form [formGroup]="filtersForm" class="filters global-filters-container">
    <lib-search-input
        [text]="$safeNavigationMigration(filtersForm.get('searchText')?.value)"
        (textChange)="filtersForm.patchValue({ searchText: $event })"
        [placeholderText]="'Details'"
    >
    </lib-search-input>
    <lib-datepicker-dropdown
        defaultTitle="Date"
        [dateFrom]="$safeNavigationMigration(filtersForm.get('dateFrom')?.value)"
        [dateTo]="$safeNavigationMigration(filtersForm.get('dateTo')?.value)"
        (dateFromChange)="filtersForm.patchValue({ dateFrom: $event })"
        (dateToChange)="filtersForm.patchValue({ dateTo: $event })"
        [dateRangeEnabled]="true"
        [isReadOnly]="false"
    >
    </lib-datepicker-dropdown>
    <app-generic-type-ahead
        [selectedItem]="$safeNavigationMigration(filtersForm.get('user')?.value)"
        placeholder="User"
        (selectedItemChange)="filtersForm.patchValue({ user: $event })"
        [service]="userServiceFilter"
        [config]="{
            defaultText: 'User',
            itemDisplayKey: 'fullName',
            itemTemplate: userTemplate
        }"
    >
    </app-generic-type-ahead>
    <ng-template #userTemplate let-data>
        <app-custom-menu-item
            [inputText]="data.inputText"
            [title]="
                $safeNavigationMigration(data.object?.firstName) + ' ' + $safeNavigationMigration(data.object?.lastName)
            "
            [subtitle]="data.object?.email ?? ''"
            [titlePrefix]="!data.object?.isActive ? { text: 'Inactive', textColor: 'danger' } : undefined"
        >
        </app-custom-menu-item>
    </ng-template>
</form>

@if (activityLogsDatasource) {
    <div class="grid">
        <app-server-side-grid
            [colDefs]="gridColumns()"
            [datasource]="activityLogsDatasource"
            [noRows]="noResults()"
            [titleNoData]="'No Activity logs available.'"
            [getRowId]="getRowIdFn"
        ></app-server-side-grid>
    </div>
}
